export default {
  "root": "_root_q9300_1",
  "close": "_close_q9300_1",
  "--hide-close": "_--hide-close_q9300_1",
  "--variant-media": "_--variant-media_q9300_1",
  "--align-center": "_--align-center_q9300_1"
};import "ni:sha-256;egl7lneg7HWk2SIKj0IzDdb2wSZBS2_6P6X-AL6zjSU";